import { render, staticRenderFns } from "./footPart.vue?vue&type=template&id=52810b64&scoped=true&"
var script = {}
import style0 from "./footPart.vue?vue&type=style&index=0&id=52810b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52810b64",
  null
  
)

export default component.exports